<template>
  <b-container fluid="lg">
    <div class="verifactu-config">
      <!-- Switch para activar/desactivar Verifactu -->
      <b-card class="mb-4">
        <b-card-header>
          <h5 class="mb-0">Estat del Sistema</h5>
        </b-card-header>
        <b-card-body>
          <b-row align-v="center">
            <b-col cols="auto">
              <b-form-checkbox
                v-model="verifactuActivo"
                switch
                size="lg"
                @change="onToggleChange"
              >
                <strong>{{ verifactuActivo ? 'Verifactu ACTIU' : 'Verifactu INACTIU' }}</strong>
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-button 
                variant="primary" 
                size="sm"
                @click="guardarEstat"
                class="ml-3"
              >
                <b-icon icon="save"></b-icon>
                Guardar Estat
              </b-button>
            </b-col>
          </b-row>
          
          <b-row class="mt-3">
            <b-col>
              <b-alert 
                :show="verifactuActivo" 
                variant="success"
                class="mb-0"
              >
                <b-icon icon="check-circle-fill"></b-icon>
                El sistema de facturació Verifactu està activat. Totes les factures es registraran automàticament.
              </b-alert>
              
              <b-alert 
                :show="!verifactuActivo" 
                variant="warning"
                class="mb-0"
              >
                <b-icon icon="exclamation-triangle-fill"></b-icon>
                El sistema de facturació Verifactu està desactivat. Les factures no es registraran.
              </b-alert>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- Configuració adicional que se muestra solo si Verifactu está activo -->
      <b-card v-if="verifactuActivo">
        <b-card-header>
          <h5 class="mb-0">Configuració Avançada</h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col md="6">
              <b-form-group label="URL del Servei:" label-for="url-servei">
                <b-form-input
                  id="url-servei"
                  v-model="configuracio.urlServei"
                  type="url"
                  placeholder="https://prewww1.aeat.es/wlpl/TIKE-CONT/"
                ></b-form-input>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label="Entorn:" label-for="entorn">
                <b-form-select
                  id="entorn"
                  v-model="configuracio.entorn"
                  :options="entornOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group label="NIF de l'Empresa:" label-for="nif-empresa">
                <b-form-input
                  id="nif-empresa"
                  v-model="configuracio.nifEmpresa"
                  placeholder="12345678A"
                  maxlength="9"
                ></b-form-input>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label="Nom de l'Empresa:" label-for="nom-empresa">
                <b-form-input
                  id="nom-empresa"
                  v-model="configuracio.nomEmpresa"
                  placeholder="Nom de la teva empresa"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <b-button 
                variant="success" 
                @click="guardarConfiguracio"
                :disabled="!configuracioValida"
              >
                <b-icon icon="save"></b-icon>
                Guardar Configuració Avançada
              </b-button>
              
              <b-button 
                variant="outline-secondary" 
                class="ml-2"
                @click="provarConnexio"
                :disabled="!configuracioValida"
              >
                <b-icon icon="wifi"></b-icon>
                Provar Connexió
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </b-container>
</template>
<script>

export default {
  name: 'VerifactuComponent',
  components: {
  },
  data() {
    return {
      entornOptions: [
        { value: 'desenvolupament', text: 'Desenvolupament' },
        { value: 'preproducció', text: 'Preproducció' },
        { value: 'producció', text: 'Producció' }
      ]
    };
  },
  computed: {
    verifactuActivo: {
      get() {
        return this.$store.getters['configuracion/verifactuActivo'];
      },
      set(value) {
        // SOLO actualizar el estado local, SIN guardar
        this.$store.commit('configuracion/SET_VERIFACTU_ACTIVO', value);
      }
    },
    configuracio: {
      get() {
        return this.$store.getters['configuracion/configuracio'];
      },
      set(value) {
        this.$store.commit('configuracion/SET_CONFIGURACIO', value);
      }
    },
    configuracioValida() {
      return this.configuracio.urlServei && 
             this.configuracio.nifEmpresa && 
             this.configuracio.nomEmpresa;
    }
  },
  async created() {
    try {
      await this.$store.dispatch('configuracion/cargarConfiguracio')
    } catch (error) {
      this.makeToast(
        'b-toaster-top-right',
        'danger',
        'Error de Càrrega',
        'No s\'ha pogut carregar la configuració de Verifactu. Verifiqueu la connexió.'
      )
      console.error('Error carregant configuració Verifactu:', error)
    }
  },
  methods: {
    onToggleChange() {
      // Solo feedback visual, NO guardado automático
      console.log(`Switch cambiado a: ${this.verifactuActivo}`);
    },

    async guardarEstat() {
      try {
        await this.$store.dispatch('configuracion/guardarConfiguracio');
        this.makeToast(
          'b-toaster-top-right',
          'success',
          'Estat Guardat',
          `Verifactu ${this.verifactuActivo ? 'activat' : 'desactivat'} correctament.`
        );
      } catch (error) {
        this.makeToast(
          'b-toaster-top-right',
          'danger',
          'Error al Guardar Estat',
          'No s\'ha pogut guardar l\'estat de Verifactu.'
        );
        console.error('Error guardant estat:', error);
      }
    },

    async guardarConfiguracio() {
      try {
        // Actualizar la configuración en el store antes de guardar
        this.$store.commit('configuracion/SET_CONFIGURACIO', this.configuracio);
        
        // Guardar toda la configuración
        await this.$store.dispatch('configuracion/guardarConfiguracio');
        
        this.makeToast(
          'b-toaster-top-right',
          'success',
          'Configuració Guardada',
          'La configuració avançada de Verifactu s\'ha guardat correctament.'
        );
      } catch (error) {
        this.makeToast(
          'b-toaster-top-right',
          'danger',
          'Error al Guardar',
          'No s\'ha pogut guardar la configuració. Torneu-ho a provar.'
        );
        console.error('Error guardant configuració:', error);
      }
    },
    
    provarConnexio() {
      // Aquí implementarás la lógica per provar la connexió
      this.makeToast(
        'b-toaster-top-right',
        'info',
        'Provant Connexió',
        'Provant la connexió amb el servei Verifactu...'
      );
    },
    
    makeToast(toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      });
    }
  }
};

</script>

<style scoped>
.verifactu-config {
  max-width: 1000px;
  margin: 0 auto;
}

.card-header h5 {
  color: #495057;
  font-weight: 600;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-switch .custom-control-label::before {
  background-color: #6c757d;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a745;
}
</style>